import { format } from 'date-fns'
import moment from 'moment'

export const formatDateFn = (date, format = 'YYYY-MM-DD HH:mm:ss', defaultString = '') => {
  try {
    return date ? moment(date).format(format) : defaultString
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('parse Date error，source date is ', date)
  }
  return ''
}

/** 格式化时间 */
export const formatTime = (timeStamp: Date | number | undefined, formatString = 'yyyy-MM-dd', defaultString = '') => {
  if (!timeStamp) {
    return defaultString
  }

  try {
    return format(timeStamp, formatString)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('parse timeStamp error，source timeStamp is ', timeStamp)
  }
  return ''
}

/**
 * 返回渲染选项的函数
 * @param options
 * @returns
 */
export function renderOptions(options: { label: string; value: any }[]) {
  return (val) => {
    return options?.find((o) => o.value === val)?.label || '-'
  }
}

export function timeRender(time: any) {
  return formatDateFn(time)
}

export function formatPeriod({ periodStartTime, periodEndTime }: any) {
  return `${moment(periodStartTime).format('YYYY-MM-DD')} - ${moment(periodEndTime - 1).format('YYYY-MM-DD')}`
}
